class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();
    this.observer = null;
    this.observedTargets = new Set();
    this.targetVisibility = new WeakMap();
    this.onDOMContentLoaded = this.observeFooter.bind(this);
  }

  connectedCallback() {
    if (this.observer || typeof IntersectionObserver !== 'function') return;

    this.observer = new IntersectionObserver(this.onIntersection.bind(this), { threshold: 0.25 });
    const mainProductForm = document.querySelector('.product-form');
    if (mainProductForm) this.observeTarget(mainProductForm);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded, { once: true });
    } else {
      this.observeFooter();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('DOMContentLoaded', this.onDOMContentLoaded);
    this.observer?.disconnect();
    this.observer = null;
    this.observedTargets.clear();
    this.targetVisibility = new WeakMap();
  }

  observeTarget(target) {
    if (!target || this.observedTargets.has(target) || !this.observer) return;
    this.observedTargets.add(target);
    this.observer.observe(target);
  }

  observeFooter() {
    this.observeTarget(document.querySelector('footer.footer'));
  }

  onIntersection(entries) {
    entries.forEach((entry) => this.targetVisibility.set(entry.target, entry.isIntersecting));
    const targetInView = Array.from(this.observedTargets).some((target) => this.targetVisibility.get(target));
    if (targetInView) {
      this.classList.remove('show');
    } else if (window.scrollY > 200) {
      this.classList.add('show');
    }
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image && newImgSrc) {
      // Sanitize and validate URL to prevent XSS
      // Remove any whitespace and HTML entities
      const sanitized = String(newImgSrc).trim().replace(/[\s<>"']/g, '');

      // Reject dangerous protocols (check anywhere in string, not just start)
      const dangerousProtocols = /^(javascript|data|vbscript|file|about):/i;
      if (dangerousProtocols.test(sanitized)) {
        return; // Reject dangerous URLs
      }

      try {
        // Try to parse as absolute URL
        const url = new URL(sanitized, window.location.origin);
        // Only allow http and https protocols
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          // Use the properly constructed URL to prevent any encoding issues
          this.image.src = url.href;
          // The variant URL is a single 128px candidate. Retaining the old
          // responsive srcset would let the browser keep displaying the
          // previous variant at wider viewport sizes.
          this.image.removeAttribute('srcset');
          this.image.removeAttribute('sizes');
        }
      } catch (e) {
        // If URL parsing fails, it's likely a relative URL
        // Additional validation: ensure it doesn't contain dangerous patterns
        if (!sanitized.includes('javascript:') &&
            !sanitized.includes('data:') &&
            !sanitized.includes('vbscript:') &&
            !sanitized.includes('<') &&
            !sanitized.includes('>')) {
          // For relative URLs, ensure proper encoding
          this.image.src = sanitized;
          this.image.removeAttribute('srcset');
          this.image.removeAttribute('sizes');
        }
      }
    }
  }
}

customElements.define('upsell-card', UpsellCard);
